import { render, staticRenderFns } from "./ImprovePerformance.vue?vue&type=template&id=6c8bd0a2"
import script from "./ImprovePerformance.vue?vue&type=script&lang=js"
export * from "./ImprovePerformance.vue?vue&type=script&lang=js"
import style0 from "./ImprovePerformance.vue?vue&type=style&index=0&id=6c8bd0a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports